import { forwardRef } from 'react'
import * as PopoverPrimitive from '@radix-ui/react-popover'
import { cn } from '@/lib/utils'
import { usePortalContainer, useOverlayLayer } from './portal-container'
import { placed, placedChild } from '@/lib/style-guard'

const Popover = PopoverPrimitive.Root
const PopoverTrigger = PopoverPrimitive.Trigger
const PopoverAnchor = PopoverPrimitive.Anchor

const PopoverContent = forwardRef<
  React.ComponentRef<typeof PopoverPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof PopoverPrimitive.Content> & { inset?: 'none' | 'sm' | 'md' }
>(({ className, align = 'end', sideOffset = 8, inset = 'none', ...props }, ref) => {
  placedChild(props.asChild ? props.children : null, 'PopoverContent')
  const container = usePortalContainer()
  const layer = useOverlayLayer('menu')
  return (
  <PopoverPrimitive.Portal container={container ?? undefined}>
    <PopoverPrimitive.Content
      ref={ref}
      align={align}
      sideOffset={sideOffset}
      className={cn(
        'z-[var(--z-dropdown)] w-80 rounded-[var(--radius-lg)]',
        'border border-[var(--border-default)] bg-[var(--surface-elevated)]',
        inset === 'md' ? 'p-3' : inset === 'sm' ? 'p-2' : 'p-0',
        'shadow-[var(--shadow-lg)]',
        'data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95',
        'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95',
        'data-[side=bottom]:slide-in-from-top-2',
        placed(className, 'PopoverContent', props)
      )}
      {...props}
      style={{ ...props.style, ...layer }}
    />
  </PopoverPrimitive.Portal>
)
})
PopoverContent.displayName = 'PopoverContent'

export { Popover, PopoverTrigger, PopoverAnchor, PopoverContent }
